//Each link that is not a parent will either have a linkPath or a linkPopup.  The linkPopup will show a modal of that component.  The linkPath will navigate to that component.
const mobileMenuLinks = [
  {
    permittedUsers: [
      { }
    ],
    linkIcon: 'columns',
    linkText: 'Dashboard',
    linkPath: '/'
  },
  { 
    permittedUsers: [
      { GroupTypeString: 'Status Solutions' },
      { GroupTypeString: 'Corporate', IsAdmin: true },
      { GroupTypeString: 'Facility', IsAdmin: true },
      { GroupTypeString: 'Family', IsAdmin: true }
    ],
    linkIcon:'cog', 
    linkText: 'Administration', 
    subLinks: [
    { 
      permittedUsers: [
        { GroupTypeString: 'Status Solutions' }
      ],
      linkIcon:'sitemap', 
      linkText: 'Organizations', 
      subLinks: [
        { 
          permittedUsers: [
            { GroupTypeString: 'Status Solutions', IsAdmin: true }
          ],
          linkText: 'New & Updated',
          linkPath: '/admin/updates'
        },
        { 
          permittedUsers: [
            { GroupTypeString: 'Status Solutions' }
          ],
          linkText: 'Facilities',
          linkPath: '/admin/facilities' 
        },
        { 
          permittedUsers: [
            { GroupTypeString: 'Status Solutions' }
          ],
          linkText: 'Corporations',
          linkPath: '/admin/corporations'
        }
      ] 
    },
    { 
      permittedUsers: [
        { GroupTypeString: 'Status Solutions', IsAdmin: true },
        { GroupTypeString: 'Corporate', IsAdmin: true },
        { GroupTypeString: 'Facility', IsAdmin: true }
      ],
      linkIcon:'briefcase', 
      linkText: 'Modules',
      linkPath: '/admin/modules' 
    },
    { 
      permittedUsers: [
        { GroupTypeString: 'Status Solutions', IsAdmin: true },
        { GroupTypeString: 'Corporate', IsAdmin: true },
        { GroupTypeString: 'Facility', IsAdmin: true },
        { GroupTypeString: 'Family', IsAdmin: true }
      ],
      linkIcon:'users', 
      linkText: 'Users & Groups', 
      subLinks: [
        { 
          permittedUsers: [
            { GroupTypeString: 'Status Solutions', IsAdmin: true },
            { GroupTypeString: 'Corporate', IsAdmin: true },
            { GroupTypeString: 'Facility', IsAdmin: true },
            { GroupTypeString: 'Family', IsAdmin: true }
          ],
          linkText: 'Users', 
          linkPath: '/admin/users'
        },
        { 
          permittedUsers: [
            { GroupTypeString: 'Status Solutions', IsAdmin: true },
            { GroupTypeString: 'Corporate', IsAdmin: true },
            { GroupTypeString: 'Facility', IsAdmin: true }
          ],
          linkText: 'Groups', 
          linkPath: '/admin/groups'
        }
      ]
    }
  ]},
  {
    permittedUsers: [
      { GroupTypeString: 'Facility', HasCorrespondenceViaGroupsOrOverride: true },
      { GroupTypeString: 'Family' }
    ],
    linkIcon: 'comments',
    linkText: 'Messages',
    linkPath: '/messages'
  },
  {
    permittedUsers: [
      { GroupTypeString: 'Facility', HasViewSurveyResponsesViaGroupsOrOverride: true }
    ],
    linkIcon: 'check',
    linkText: 'Survey Results',
    linkPath: '/responses'
  },
  {
    permittedUsers: [
      { GroupTypeString: 'Status Solutions' },
      { GroupTypeString: 'Corporate' },
      { GroupTypeString: 'Facility' }
    ],
    linkIcon: 'satellite-dish',
    linkText: 'Devices',
    linkPath: '/devices'
  },
  {
    permittedUsers: [
      { GroupTypeString: 'Status Solutions' },
      { GroupTypeString: 'Corporate' },
      { GroupTypeString: 'Facility' }
    ],
    linkIcon: 'clipboard-list',
    linkText: 'Reports',
    subLinks: [
      {
        permittedUsers: [
        //  TODO:  Put back in when we fix the staff check in report with survey data,
        //  { GroupTypeString: 'Status Solutions' },
        //  { GroupTypeString: 'Corporate' },
        //  { GroupTypeString: 'Facility' }
        ],
        linkText: 'Staff Check-In',
        linkPath: '/reports/2'
      },
      {
        permittedUsers: [
          { GroupTypeString: 'Status Solutions' },
          { GroupTypeString: 'Corporate' },
          { GroupTypeString: 'Facility' }        ],
        linkText: 'Mood History',
        linkPath: '/reports/3'
      },
      {
        permittedUsers: [
          { GroupTypeString: 'Status Solutions' },
          { GroupTypeString: 'Corporate' },
          { GroupTypeString: 'Facility' }
        ],
        linkText: 'Alarm History',
        linkPath: '/reports/4'
      },
      {
        permittedUsers: [
          { GroupTypeString: 'Status Solutions' },
          { GroupTypeString: 'Corporate' },
          { GroupTypeString: 'Facility' }
        ],
        linkText: 'Alarm Average Response Time',
        linkPath: '/reports/5'
      }      
    ]
  },
  {
    permittedUsers: [
      {}
    ],
    linkIcon: 'user',
    linkText: 'My Profile',
    linkPopup: 'ProfileModal'
  },
  {
    permittedUsers: [
      { }
    ],
    linkIcon: 'sign-out-alt',
    linkText: 'Logout',
    linkPath: '/logout'
  },
]

export default mobileMenuLinks;